<template>
  <div class="text-menu-component" tabindex="0" aria-label="文本菜单">
    <div class="menu-section">
      <p class="section-title">字号大小</p>
      <ul class="size-list" role="radiogroup" aria-label="字号大小">
        <li
          v-for="size in fontSizes"
          :key="size"
          :class="{ active: selectedFontSize === size }"
          @click="handleFontSizeSelect(size)"
          :aria-checked="selectedFontSize === size"
          role="radio"
          tabindex="0"
          @keydown.enter.space="handleFontSizeSelect(size)"
        >
          <span class="size-value">{{ size }}</span>
        </li>
      </ul>
    </div>
    <div class="divider"></div>
    <div class="menu-section">
      <p class="section-title">字体颜色</p>
      <ul class="color-list" role="radiogroup" aria-label="画笔颜色">
        <li
          v-for="color in penColors"
          :key="color"
          :class="{ active: selectedColor === color }"
          @click="handleColorSelect(color)"
          :aria-checked="selectedColor === color"
          role="radio"
          tabindex="0"
          @keydown.enter.space="handleColorSelect(color)"
        >
          <span
            class="color-dot"
            :style="{ backgroundColor: color }"
            :aria-label="'颜色' + color"
          >
            <span v-if="selectedColor === color" class="color-selected"></span>
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "TextMenu",
  data() {
    return {
      fontSizes: [14, 16, 18, 20],
      penColors: [
        "#000000",
        "#E2584F",
        "#F6C847",
        "#65C445",
        "#456FF6",
        "#7640EC",
      ],
      selectedFontSize: 14,
      selectedColor: "#000000",
    };
  },
  mounted() {
    const initColor = this.whiteBoardService.getTextColor();
    const initSize = this.whiteBoardService.getTextSize();
    this.selectedColor = this.rgbaToHex(initColor);
    this.selectedFontSize = initSize ? +initSize : 14;
  },
  methods: {
    rgbaToHex(rgba) {
      const result = rgba.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/i);
      if (!result) return "#cccccc";
      const r = parseInt(result[1]).toString(16).padStart(2, "0");
      const g = parseInt(result[2]).toString(16).padStart(2, "0");
      const b = parseInt(result[3]).toString(16).padStart(2, "0");
      return `#${r}${g}${b}`.toUpperCase();
    },
    handleFontSizeSelect(size) {
      if (this.selectedFontSize === size) return;
      this.selectedFontSize = size;
      this.handleStyleChange();
    },
    handleColorSelect(color) {
      if (this.selectedColor === color) return;
      this.selectedColor = color;
      this.handleStyleChange();
      this.$emit("color-change", color);
    },
    handleStyleChange() {
      this.whiteBoardService.setTextStyle({
        color: this.selectedColor,
        size: this.selectedFontSize,
      });
    },
  },
  computed: {
    ...mapState("live", ["whiteBoardService"]),
  },
};
</script>

<style lang="scss" scoped>
.text-menu-component {
  width: 167px;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(20, 20, 43, 0.04);
  border-radius: 10px;
  border: 1px solid $live-room-border-color;
  padding: 0 12px;

  .menu-section {
    padding: 12px 0 4px;
    border-bottom: 1px solid $live-room-border-color;

    &:last-child {
      border: none;
    }
  }

  .section-title {
    font-weight: 500;
    font-size: 12px;
    color: #4e5969;
    line-height: 20px;
    margin-bottom: 4px;
  }

  ul {
    display: flex;
    flex-wrap: wrap;
    li {
      margin-top: 8px;
      margin-bottom: 8px;
    }
  }

  .size-list {
    li {
      width: 28px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.3s;
      margin-right: 9px;
      font-weight: 500;
      font-size: 14px;
      color: #1d2129;
      line-height: 1;
      &:nth-child(4n) {
        margin-right: 0;
      }
      &:hover,
      &:focus {
        background: $live-room-hover-bg;
      }
      &.active {
        background: $live-room-active-bg;
      }
    }
  }

  .color-list {
    li {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      position: relative;
      margin-right: 40px;
      &:nth-child(3n) {
        margin-right: 0;
      }

      &.active::after,
      &:hover::after {
        display: block;
        content: "";
        width: 12px;
        height: 12px;
        border-radius: 50%;
        border: 2px solid #ffffff;
        background: transparent;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      .color-dot {
        width: 20px;
        height: 20px;
        border-radius: 50%;
      }
    }
  }
}
</style>
